import React, { useContext, useState } from 'react';
import { View, Pressable, Text } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import AuthContext from 'app/src/contexts/AuthContext';
import DataState from 'app/src/components/DataState';
import {
  MainContainer,
  ContentContainer,
  TableContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
  SubNavContainer,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import SubNav from 'app/src/elements/SubNav';

import NewPreBidSchedule from './new';
import EditPreBidSchedule from './edit';
import { PRE_BID_SCHEDULES, HIDE_PRE_BID_SCHEDULE } from './queries';

const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const DAYS_OF_WEEK_OPTIONS = DAYS_OF_WEEK.map((name, index) => (
  { value: index, label: name }
));

const PreBidSchedules = () => {
  const { hasPolicy } = useContext(AuthContext);
  const [showAdd, setShowAdd] = useState();
  const [showEdit, setShowEdit] = useState();

  const { data, refetch } = useQuery(PRE_BID_SCHEDULES);

  const [hidePreBidSchedule] = useMutation(HIDE_PRE_BID_SCHEDULE, {
    onCompleted: refetch
  });

  if (!data) { return <DataState.Loading />; }

  const onHide = preBidSchedule => {
    if (window.confirm(`Hide ${preBidSchedule.name}?`)) {
      hidePreBidSchedule({ variables: { id: preBidSchedule.id }});
    }
  };

  const columns = [
    {
      key: 'name',
      label: 'Name',
    },
    {
      key: 'saleWeekday',
      label: 'Default for Day',
      value: ({ value }) => value ? DAYS_OF_WEEK[value] : '',
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <LinkContainer>
          <Pressable onPress={() => setShowEdit(entry)}>
            <Text>View/Edit</Text>
          </Pressable>
          <LinkSpace/>
          {hasPolicy({ type: 'PreBidSchedule', action: 'hide' }) && (
            <Pressable onPress={() => onHide(entry)}>
              <Text>Hide</Text>
            </Pressable>
          )}
        </LinkContainer>
      )
    }
  ];

  return (
    <MainContainer>
      <SubNavContainer>
        <SubNav>
          <View>
            <Pressable onPress={() => setShowAdd(true)}>
              <Text>+ Add Pre-Bid Pricing Schedule</Text>
            </Pressable>
          </View>
        </SubNav>
      </SubNavContainer>
      <ContentContainer>
        <PageTitle>Pre-Bid Pricing Schedules</PageTitle>
        <br /><br />
        <TableContainer>
          <DataTable.Simple
            data={data.preBidSchedules}
            columns={columns}
          />
        </TableContainer>
      </ContentContainer>

      {showAdd &&
        <Modal
          refetch={refetch}
          showModal={showAdd}
          setShowModal={setShowAdd}
          modalType={'Add Pre-Bid Pricing Schedule'}
        >
          <NewPreBidSchedule
            setShowModal={setShowAdd}
            refetch={refetch}
            preBidSchedule={showAdd}
          />
        </Modal>
      }

      {showEdit &&
        <Modal
          refetch={refetch}
          showModal={showEdit}
          setShowModal={setShowEdit}
          modalType={'Edit Pre-Bid Schedule'}
          objectName={showEdit.name}
        >
          <EditPreBidSchedule
            setShowModal={setShowEdit}
            refetch={refetch}
            preBidSchedule={showEdit}
          />
        </Modal>
      }
    </MainContainer>
  );
};

export default PreBidSchedules;
